'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');
var mouseHelper = require('../../helper/mouseHelper');
var versionHelper = require('../../helper/versionHelper');
var interactiveManager = require('../../interactive/InteractiveManager');
var LinkArea = require('../common/LinkArea');
var RuntimeOptions = require('../RuntimeOption.js');
var Log = require('../Mixin/Log');
var util = require('../../helper/util');

var stateInteractive = require('../../interactive/stateInteractive');

var Component = React.createClass({
  propTypes: {
    controlID: React.PropTypes.string.isRequired
  },
  mixins: [Log],

  getInitialState: function () {
    return {};
  },
  render: function () {
    if (this.state.error) {
      return (
        <div
          id={this.props.controlID}
          key={this.props.controlID}
          style={this.getCommonStyle()}
          className={'component component-render-error component-' + this.props.controlTypeID.replace(/[()]/g, '_')}
        >
          Error in render {this.props.controlTypeID}.
        </div>
      );
    }
    var _props = _.extend({}, this.props, this.state);
    var style = this.getCommonStyle();
    var className = 'component component-' + this.props.controlTypeID.replace(/[()]/g, '_');
    if (!_.isEmpty(this.props.remarkText)) {
      className += ' component-with-remark';
    }
    return (
      <div id={this.props.controlID}
           key={this.props.controlID}
           className={className}
           style={style}
           onClick={this._onClick}
           onMouseUp={this._onMouseUp}
           onMouseDown={this._onMouseDown}
           onMouseOver={this._onMouseOver}
           onMouseOut={this._onMouseOut}
           onMouseMove={this._onMouseMove}
           onMouseEnter={this._onMouseEnter}
           onMouseLeave={this._onMouseLeave}>
        {this.renderChildren(_props)}
        {
          (this.props.controlTypeID !== 'Accordion'
          && this.props.controlTypeID !== '__group__'
          && this.props.controlTypeID !== 'Panel'
          && this.props.controlTypeID !== 'Tree'
          && this.props.controlTypeID !== 'TextInput'
          && this.props.controlTypeID !== 'Timer') &&
          <LinkArea
            k={this.props.controlID + 'linkArea'}
            links={this.props.links}
            interactive={this.props.interactiveData}
            size={{
              width: _.isUndefined(this.props.currentW) ? this.props.w : this.props.currentW,
              height: _.isUndefined(this.props.currentH) ? this.props.h : this.props.currentH
            }}
            externalURL={this.props.externalURL}
            onLinkEvent={this._onLinkEvent}
            onLongPressEvent={this._onLongPress}
            onDblClick={this._onDblClick}
            onRightClick={this._onRightClick}
          />
        }
      </div>)
  },

  _onLinkEvent: function (evt, linkKey, index) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    if (this.props.controlTypeID === 'CheckBox') {
      $(ReactDOM.findDOMNode(this).children[0]).trigger('checkedChange', {key: linkKey, nativeEvent: evt});
      return;
    } else if (this.props.controlTypeID === 'CheckBoxGroup') {
      $(ReactDOM.findDOMNode(this).children[0]).trigger('checkedChange', {
        key: linkKey,
        index: index,
        nativeEvent: evt
      });
      return;
    }
    this.props.events.doSelfClick(evt, this.props, linkKey, index);
    //当组件上有交互或者页面链接时，会创建出一个LinkArea的层，它会阻挡住多链接组件中项目切换时的点击事件
    //通过这种方式派发到组件本身上面
    //需要在组件本身的componentDidMount中，绑定一个itemClick事件
    $(ReactDOM.findDOMNode(this).children[0]).trigger('itemClick', [index, linkKey, evt]);
    evt.stopPropagation();
  },

  _onClick: function (e) {
    //此处当组件上没有链接或交互时，LinkArea尺寸为0，则点击不上，故在此处响应外部链接的点击
    if (this.props.externalURL) {
      this._onLinkEvent(e, 'url-link');
    }
  },

  _onLongPress: function (evt, index) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    if (this.props.events.doSelfLongPress)
      this.props.events.doSelfLongPress(evt, this.props, index)
  },

  _onRightClick: function (evt, index) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    if (this.props.events.doSelfRightClick) {
      this.props.events.doSelfRightClick(evt, this.props, index);
    }
  },

  _onDblClick: function (evt, index) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    if (this.props.events.doSelfDbClick) {
      this.props.events.doSelfDbClick(evt, this.props, index);
    }

    //兼容组件内部双击交互事件，比如树组件的收缩展开
    $(ReactDOM.findDOMNode(this).children[0]).trigger('itemDbClick',index);
  },

  renderChildren: function (props) {
    var _this = this;
    return React.Children.map(props.children, function (child) {
      return React.cloneElement(child, _this.state);
    });
  },

  getCommonStyle: function () {
    var interactiveState = interactiveManager.getInteractiveState();
    if(interactiveState.isRuning(this.props.controlID)) {       //执行交互过程中使用原css，让jquery执行，react先不引起更新
      return this.historyCss;
    }

    var opacity = styleHelper.getOpacity(this);
    var isShow = styleHelper.getVisible(this);
    var order = styleHelper.getOrder(this.props);
    var css = {
      left: styleHelper.getX(this.props),
      top: styleHelper.getY(this.props),
      width: styleHelper.getWidth(this.props, this.state),
      height: styleHelper.getHeight(this.props, this.state),
      padding: 0,
      opacity: opacity,
      zIndex: order
    };
    if (!isShow) {
      css.visibility = 'hidden';
      css.pointerEvents = 'none';
      if(!versionHelper.isPageVersionLowerThan4_9()) {
        css.opacity = 0;
      }
    }
    this.historyCss = css;
    return css;
  },

  getInteractiveWorkingStyle: function() {
    var opacity = styleHelper.getOpacity(this);

    var css = {
      left: this.props.x,
      top: this.props.y,
      width: this.props.w,
      height: this.props.h,
      padding: 0,
      //overflow: 'visible',

      pointerEvents: this.props.isShow ? 'auto' : 'none',     //Allen:组件隐藏是点击事件穿透到下方
      opacity: this.props.isShow ? opacity : 0,
      zIndex: this.props.zOrder
    };
    return css;
  },

  /**
   * 是否可见
   * @returns {string}‘visible’or 'hidden'
   */
  isVisible: function () {
    return _.isUndefined(this.props.isShow) || this.props.isShow;
  },

  componentDidUpdate: function (newProps) {
    if (this.state.showRemark && !this.listeningOnMouseMove) {
      this.listeningOnMouseMove = true;
      mouseHelper.onMove(this._onMouseMove);
    }

    if (!this.state.showRemark && this.listeningOnMouseMove) { // 不需要再显示备注了
      this.listeningOnMouseMove = null;
      mouseHelper.offMove(this._onMouseMove);
    }

    var componentDom = ReactDOM.findDOMNode(this);
    var isShow = styleHelper.getVisible(this);
    //this.updateChildDomVisible(componentDom, isShow);
  },

  componentWillUnmount: function () {
    if (this.state.showRemark) { // 如果正在显示备注
      this.listeningOnMouseMove = null;
      mouseHelper.offMove(this._onMouseMove);
      this.props.events.onShowRemark(0, 0, '');
    }
  },

  componentDidMount: function () {
    this.stateInteractiveManaer = new stateInteractive(this);
    var componentDom = ReactDOM.findDOMNode(this);
    $(componentDom).css({transform: 'scaleX(1) scaleY(1)'});

    var isShow = styleHelper.getVisible(this);
    //this.updateChildDomVisible(componentDom, isShow);
  },

  domVisibleArray: [],
  //此处更新子元素可见性不是一个好的方案
  updateChildDomVisible: function(dom, isShow) {
    if(!isShow) {
      var children = $(dom).children();
      for(var i=0;i<children.length;i++) {
        var child = children[i];
        var className = $(child).attr("class");
        if(className === undefined || className.indexOf('component component-') === -1) {
          var v = $(child).css('visibility');
          if(v && v !== "hidden") {
            var node = {
              dom: child,
              value: v
            };
            this.domVisibleArray.push(node);
            $(child).css({visibility: 'hidden'});
          }

          this.updateChildDomVisible(child, isShow);
        }
      }
    } else {
      for(var i=0;i<this.domVisibleArray.length;i++) {
        var node = this.domVisibleArray[i];
        $(node.dom).css({visibility: node.value});
      }
      this.domVisibleArray = [];
    }

  },
  /**
   * 判断当前组件上是否有交互
   * @returns {boolean}
   */
  hasLinkOrInteractive: function () {
    var links;
    var link;
    var interactiveData;
    var entry;
    var event;
    var i = 0;
    var result = false;
    links = this.props.links;
    interactiveData = this.props.interactiveData;
    for (i; i < links.length; i++) {
      link = links[i];
      if (link.targetPageID && link.linkType === 'ltPageLink') {
        return true;
      }
    }

    //todo : mengxiaojiang 多入口是否有交互判断还未完成
    //i = 0;
    //for(i ; i< interactiveData.entry.length;i++){
    //
    //}
  },

  displayLinkArea: function (isShow, isAnimate) {
    var linkArea;
    var toOpacity = 0.4;
    var fromOpacity = 0;
    if (!isShow) {
      fromOpacity = toOpacity;
      toOpacity = 0;
    }
    if ((this.props.showLinkAreaInMouseHover || this.props.displayLinkArea) && this.state.hasLinkOrInteractive) {
      linkArea = $('#linkArea_' + this.props.controlID);
      if (isAnimate) {
        linkArea.css({opacity: fromOpacity}).transition({opacity: toOpacity, duration: 400});
      } else {
        linkArea.css({opacity: toOpacity});
      }
    }
  },

  _onMouseUp: function (e) {
    this.mousePress = false;
    var isShow = styleHelper.getVisible(this);
    if (isShow) {
      this.stateInteractiveManaer.mouseUp(e);
      this.displayLinkArea(false);
    }
  },

  _onMouseDown: function (e) {
    this.mousePress = true;
    //this.doTriggerStates(appTypes.StateEventType.MOUSE_DOWN, true);

    this.stateInteractiveManaer.mouseDown(e);
    this.displayLinkArea(true);
  },

  _onMouseOver: function (e) {
    this.stateInteractiveManaer.mouseEnter(e);
  },

  _onMouseOut: function (e) {
    // var isShow = styleHelper.getVisible(this);
    // if (isShow) {
    //   //this.stateInteractiveManaer.mouseLeave(e);
    //   this.displayLinkArea(false);
    // }
    var isShow = styleHelper.getVisible(this);
    if (isShow) {
      this.stateInteractiveManaer.mouseLeave(e);
      this.displayLinkArea(false);
    }
    //var isShow = styleHelper.getVisible(this);
    //if (isShow) {
    //  this.stateInteractiveManaer.mouseLeave(e);
    //  this.displayLinkArea(false);
    //}
  },

  _onMouseEnter: function (e) {
    var self = this;
    e.cancelBubble = true;
    this.stateInteractiveManaer.mouseEnter(e);
    this.displayLinkArea(true);
    //this.stateInteractiveManaer.mouseEnter(e);
    //this.displayLinkArea(true);
    this.stateInteractiveManaer.mouseEnter(e);
    //this.displayLinkArea(true);
    if (!_.isEmpty(this.props.remarkText)) {
      var rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
      this.setState({
        showRemark: true
      }, function () {
        if(self.props.events && self.props.events.onShowRemark) {
          self.props.events.onShowRemark(rect.left + rect.width, rect.top + rect.height, this.props.remarkText);
        }
      });
    }
  },

  _onMouseLeave: function (e) {
    var self = this;
    var isShow = styleHelper.getVisible(this);
    if (isShow) {
      this.stateInteractiveManaer.mouseLeave(e);
      this.displayLinkArea(false);
    }
    //var isShow = styleHelper.getVisible(this);
    //if (isShow) {
    //  this.stateInteractiveManaer.mouseLeave(e);
    //  this.displayLinkArea(false);
    //}
    var isShow = styleHelper.getVisible(this);
    if (isShow) {
      this.stateInteractiveManaer.mouseLeave(e);
      this.displayLinkArea(false);
    }
    if (this.state.showRemark) {
      this.setState({
        showRemark: false
      }, function () {
        if(self.props.events && self.props.events.onShowRemark) {
          self.props.events.onShowRemark(0, 0, '');
        }
      });
    }
  },

  /**
   * 监听 mouse move 事件
   * @param e
   * @private
   */
  _onMouseMove: function (e) {
    //this._onMouseOver(e);
    this._onMouseOver(e);
  }
});

module.exports = Component;



// WEBPACK FOOTER //
// ./src/views/Components/Component.jsx